import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ImageChecker from "../../Generic/ImageChecker";
import { errorParser, numberWithCommas } from "../../../utils/helpers";
import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
} from "../../../Redux/actions/crudActions";

import {
  getMenuItems,
  setSale,
} from "../../../Redux/actions/dailysalesActions";

import { getProduct } from "../../../Redux/actions/productActions";
import { setProductInventory } from "../../../Redux/actions/inventoryActions";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const { menuitems } = useSelector(
    (state) => ({
      menuitems: state.dailysales.menuitems,
    }),
    shallowEqual
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [categorized, setCategorized] = useState([]);
  const [itemcount, setItemcount] = useState({});
  const [itemcount_reg, setItemcount_reg] = useState({});
  const [itemcount_fp, setItemcount_fp] = useState({});
  const [itemcount_grab, setItemcount_grab] = useState({});

  const [createDate, setCreatedDate] = useState(moment());

  const [sellTotal, setSellTotal] = useState(0);

  useEffect(() => {
    calculateSellTotal(itemcount);
  }, [itemcount]);

  useEffect(() => {
    if (isModalVisible) {
      dispatch(getMenuItems());
    }
  }, [isModalVisible]);

  useEffect(() => {
    if (menuitems) {
      docategorized();
      console.log(menuitems);
    }
  }, [menuitems]);

  const docategorized = () => {
    var categories = [];

    menuitems.map((it) => {
      if (!categories.includes(it.category_name)) {
        categories.push(it.category_name);
      }
    });
    var newcats = [];
    categories.map((ct) => {
      var catprods = [];
      menuitems.map((it) => {
        if (ct == it.category_name) {
          catprods.push(it);
        }
      });
      var sortedprods = catprods.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
      var newcatp = {
        category: ct,
        products: sortedprods,
      };
      newcats.push(newcatp);
    });

    console.log(newcats);
    setCategorized(newcats);
  };

  const changequantity = (prod, count) => {
    var newItemCount = { ...itemcount };
    newItemCount[prod] = count ?? 0;
    setItemcount(newItemCount);
    console.log(newItemCount);
  };

  const changequantity_reg = (prod, count) => {
    var newItemCount = { ...itemcount_reg };
    newItemCount[prod] = count ?? 0;
    setItemcount_reg(newItemCount);
    //ADD TO MAIN QTY
    var newsum =
      parseFloat(itemcount_grab[prod] ?? 0) +
      parseFloat(itemcount_fp[prod] ?? 0) +
      parseFloat(count ?? 0);
    changequantity(prod, newsum);
    console.log(newsum);
  };

  const changequantity_fp = (prod, count) => {
    var newItemCount = { ...itemcount_fp };
    newItemCount[prod] = count ?? 0;
    setItemcount_fp(newItemCount);
    var newsum =
      parseFloat(itemcount_reg[prod] ?? 0) +
      parseFloat(itemcount_grab[prod] ?? 0) +
      parseFloat(count ?? 0);
    changequantity(prod, newsum);
    console.log(newsum);
  };

  const changequantity_grab = (prod, count) => {
    var newItemCount = { ...itemcount_grab };
    newItemCount[prod] = count ?? 0;
    setItemcount_grab(newItemCount);
    var newsum =
      parseFloat(itemcount_reg[prod] ?? 0) +
      parseFloat(itemcount_fp[prod] ?? 0) +
      parseFloat(count ?? 0);
    changequantity(prod, newsum);
    console.log(newsum);
  };

  const calculateSellTotal = (thisitemcount) => {
    var sell_total = 0;

    Object.entries(thisitemcount).map((item) => {
      console.log(item);
      var item_id = item[0];
      var item_quantity = item[1];

      if (item_quantity > 0) {
        var current_prod = menuitems.filter((x) => x.key == item_id);
        if (current_prod[0]) {
          current_prod = current_prod[0];

          var sell_subtotal = 0;
          var subtotal_reg = 0;
          var subtotal_grab = 0;
          var subtotal_fp = 0;
          var subtotal_qty = 0;
          if (itemcount_reg?.[current_prod.id] && current_prod.sell_price) {
            subtotal_reg =
              parseFloat(itemcount_reg[current_prod.id]) *
              parseFloat(current_prod.sell_price);
            subtotal_qty =
              parseFloat(subtotal_qty) +
              parseFloat(itemcount_reg[current_prod.id]);
          }

          if (itemcount_grab?.[current_prod.id] && current_prod.grab_price) {
            subtotal_grab =
              parseFloat(itemcount_grab[current_prod.id]) *
              parseFloat(current_prod.grab_price);
            subtotal_qty =
              parseFloat(subtotal_qty) +
              parseFloat(itemcount_grab[current_prod.id]);
          }

          if (itemcount_fp?.[current_prod.id] && current_prod.fp_price) {
            subtotal_fp =
              parseFloat(itemcount_fp[current_prod.id]) *
              parseFloat(current_prod.fp_price);
            subtotal_qty =
              parseFloat(subtotal_qty) +
              parseFloat(itemcount_fp[current_prod.id]);
          }

          sell_subtotal =
            parseFloat(subtotal_reg) +
            parseFloat(subtotal_grab) +
            parseFloat(subtotal_fp);

          sell_total = parseFloat(sell_total) + parseFloat(sell_subtotal);
        }
      }
    });

    console.log(sell_total);
    setSellTotal(sell_total);
  };

  const renderTable = (currentgroup) => {
    const columns = [
      {
        title: "Image",

        render: (text, record, index) => {
          return (
            <ImageChecker
              url={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
              success={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
              fail={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}logo.jpg`}
                  alt="image"
                  className={"prodimage"}
                />
              }
            />
          );
        },
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: {
          compare: (a, b) => a.name - b.name,
        },

        search: "name",
      },
      {
        title: "count",

        render: (text, record, index) => {
          return (
            <div className="scalingcontainer">
              <span className="item">REGULAR</span>
              <InputNumber
                min={0}
                width={"100%"}
                defaultValue={0}
                step={1}
                className="item"
                onChange={(e) => {
                  changequantity_reg(record.id, e);
                }}
              />
              <span className="item">GRAB</span>

              <InputNumber
                min={0}
                width={"100%"}
                defaultValue={0}
                step={1}
                className="item"
                onChange={(e) => {
                  changequantity_grab(record.id, e);
                }}
              />
              <span className="item">FOODPANDA</span>

              <InputNumber
                min={0}
                width={"100%"}
                defaultValue={0}
                step={1}
                className="item"
                onChange={(e) => {
                  changequantity_fp(record.id, e);
                }}
              />
            </div>
          );
        },
      },
    ];

    return (
      <Collapse defaultActiveKey={["1"]} className={"category_containter"}>
        <Panel header={currentgroup.category} key="1">
          <Table
            columns={columns}
            dataSource={currentgroup.products}
            pagination={false}
            showHeader={false}
          />
        </Panel>
      </Collapse>
    );
  };

  const summarizeSale = (thisitemcount) => {
    var ingredient_ids = [];
    var ingredients_base = [];
    var ingredients_count = [];

    var products_sold = [];
    console.log("thisitemcount", thisitemcount);

    console.log("menuitems", menuitems);

    var sell_total = 0;

    Object.entries(thisitemcount).map((item) => {
      console.log(item);
      var item_id = item[0];
      var item_quantity = item[1];

      if (item_quantity > 0) {
        var current_prod = menuitems.filter((x) => x.key == item_id);
        if (current_prod[0]) {
          current_prod = current_prod[0];

          var sell_subtotal = 0;
          var subtotal_reg = 0;
          var subtotal_grab = 0;
          var subtotal_fp = 0;
          var subtotal_qty = 0;
          if (itemcount_reg?.[current_prod.id] && current_prod.sell_price) {
            subtotal_reg =
              parseFloat(itemcount_reg[current_prod.id]) *
              parseFloat(current_prod.sell_price);
            subtotal_qty =
              parseFloat(subtotal_qty) +
              parseFloat(itemcount_reg[current_prod.id]);
          }

          if (itemcount_grab?.[current_prod.id] && current_prod.grab_price) {
            subtotal_grab =
              parseFloat(itemcount_grab[current_prod.id]) *
              parseFloat(current_prod.grab_price);
            subtotal_qty =
              parseFloat(subtotal_qty) +
              parseFloat(itemcount_grab[current_prod.id]);
          }

          if (itemcount_fp?.[current_prod.id] && current_prod.fp_price) {
            subtotal_fp =
              parseFloat(itemcount_fp[current_prod.id]) *
              parseFloat(current_prod.fp_price);
            subtotal_qty =
              parseFloat(subtotal_qty) +
              parseFloat(itemcount_fp[current_prod.id]);
          }

          sell_subtotal =
            parseFloat(subtotal_reg) +
            parseFloat(subtotal_grab) +
            parseFloat(subtotal_fp);

          sell_total = parseFloat(sell_total) + parseFloat(sell_subtotal);

          var recorded_product = {
            ...current_prod,
            quantity_sold: item_quantity,
            sell_subtotal: sell_subtotal,
            subtotal_qty,
            subtotal_reg,
            subtotal_grab,
            subtotal_fp,
            qty_reg: itemcount_reg[current_prod.id] ?? 0,
            qty_grab: itemcount_grab[current_prod.id] ?? 0,
            qty_fp: itemcount_fp[current_prod.id] ?? 0,
          };

          products_sold.push(recorded_product);
        }
        if (current_prod.ingredients) {
          current_prod.ingredients.map((ingrd) => {
            var new_ingrd = {
              ...ingrd,
              quantity: parseFloat(ingrd.quantity) * parseFloat(item_quantity),
            };
            ingredients_count.push(new_ingrd);

            if (!ingredient_ids.includes(new_ingrd.product)) {
              var ind_base = {
                product: new_ingrd.product,
                product_name: new_ingrd.product_name,
              };
              ingredient_ids.push(new_ingrd.product);
              ingredients_base.push(ind_base);
            }
          });
        }
      }
    });

    // console.log(ingredients_base)
    // console.log(ingredients_count)

    var ingredient_final = [];

    ingredients_base.map((ingd) => {
      var all_has = ingredients_count.filter((i) => i.product == ingd.product);

      var product_total = 0;
      all_has.map((same_prod) => {
        product_total = product_total + parseFloat(same_prod.quantity);
      });

      var new_count = {
        ...ingd,
        quantity: product_total,
      };

      ingredient_final.push(new_count);
    });

    // console.log("products_sold", products_sold);
    if (products_sold.length > 0) {
      createSale(products_sold, ingredient_final, sell_total);
    } else {
      message.warning("select item");
    }
  };

  const createSale = async (products_sold, ingredient_final, sell_total) => {
    console.log("products_sold", products_sold);
    console.log(ingredient_final);

    var resellProducts = [];
    products_sold.forEach((product) => {
      if (product.is_resell == true) {
        resellProducts.push(product);
      }
    });

    if (!loading) {
      setLoading(true);
      message.info("recording sales");
      var save_ingredients = [];
      await Promise.all(
        ingredient_final.map(async (indx, i) => {
          var product3 = await dispatch(
            setProductInventory(
              indx.product,
              indx.product_name,
              indx.quantity,
              "subtract",
              "used"
            )
          );
          var prodsource = await dispatch(getProduct(indx.product));
          if (prodsource) {
            var newingredient = {
              ...indx,
              category: prodsource.category ? prodsource.category : "",
              category_name: prodsource.category_name
                ? prodsource.category_name
                : "",
              cost_peso: prodsource.cost_peso ? prodsource.cost_peso : 0,
              cost_rmb: prodsource.cost_rmb ? prodsource.cost_rmb : 0,
              sell_price: prodsource.sell_price ? prodsource.sell_price : 0,
              second_unit: prodsource.second_unit ? prodsource.second_unit : 0,
              unit: prodsource.unit ? prodsource.unit : "",
              quantity: indx.quantity,
            };

            save_ingredients.push(newingredient);
          } else {
            message.error(indx.product_name + " not found");
          }
          message.info(
            `(${i + 1}/${ingredient_final.length})  ${
              indx.product_name
            } updated`
          );
        })
      );
      await Promise.all(
        resellProducts.map(async (indx, i) => {
          var product4 = await dispatch(
            setProductInventory(
              indx.id,
              indx.name,
              indx.quantity_sold,
              "subtract",
              "sold"
            )
          );
        })
      );

      var newsold = await dispatch(
        setSale(products_sold, save_ingredients, createDate, sell_total)
      );

      setLoading(false);
      closeModal("reset");
    }
  };
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  };

  const footer = () => {
    return (
      <div className="addsalesfooter">
        <div>
          <DatePicker
            defaultValue={createDate}
            value={createDate}
            disabledDate={disabledDate}
            onChange={(e) => {
              setCreatedDate(e);
            }}
          />
        </div>
        <div className="addsalesfooter">
          <div className="sell-price">
            <span> total sell price: </span>
            <span>{`₱ ${numberWithCommas(
              parseFloat(sellTotal).toFixed(2)
            )}`}</span>
          </div>

          <Popconfirm
            title="Are you sure this list is correct?"
            onConfirm={() => {
              summarizeSale(itemcount);
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary" loading={loading}>
              add
            </Button>
          </Popconfirm>
        </div>
      </div>
    );
  };

  const closeModal = (action) => {
    if (!loading) {
      setItemcount([]);

      setIsModalVisible(false);
      onModalClose(action);
    }
  };

  return (
    <>
      <div className={"addeditbutton"}>
        <Button
          type="primary"
          shape="round"
          icon={<PlusOutlined />}
          onClick={() => {
            setIsModalVisible(true);
            setLoading(false);
          }}
        >{`Add Daily Sales`}</Button>
      </div>

      {isModalVisible ? (
        <Modal
          title={`Add Daily Sales`}
          visible={isModalVisible}
          footer={footer()}
          onCancel={() => {
            closeModal();
          }}
        >
          <div className="dailysalesmodal-content">
            {categorized.map((cat) => {
              return renderTable(cat);
            })}
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
